import { StatusChip, type StatusTone } from '~/components/ui';
import { templateStatus, templateStatusLabel } from '~/lib/notification/templateForm';
import type { Template, TemplateStatus } from '~/modules/query/notification/types';

const TONES: Record<TemplateStatus['kind'], StatusTone> = {
  notLive: 'neutral',
  live: 'success',
  liveWithDraft: 'warning',
};

/** The status of a template, from its latest record: never a `?version=` record. */
export default function TemplateStatusChip({
  latest,
  testId,
}: {
  latest: Template;
  testId?: string;
}) {
  const status = templateStatus(latest);
  return (
    <StatusChip label={templateStatusLabel(status)} tone={TONES[status.kind]} dot testId={testId} />
  );
}
